import { render, staticRenderFns } from "./managerOverview.vue?vue&type=template&id=020c0731"
import script from "./managerOverview.vue?vue&type=script&lang=js"
export * from "./managerOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports